import React from 'react'

import { FilterItemTag, Menus_MenuItemTag } from 'src/apollo/onlineOrdering'
import { t } from 'src/translations'

import { FilterOptionRows } from './FilterOptionRows'
import { FilterVariant, filterName } from '../filterUtils'

export type TagsFilterProps = {
  tags: Menus_MenuItemTag[]
  variant: FilterVariant
  hasEntered: boolean
  selectedTags: FilterItemTag[]
  handleTagToggle: (
    guid: string | null | undefined,
    name: string | null | undefined
  ) => void
}
export const TagsFilter = ({
  tags,
  variant,
  hasEntered,
  selectedTags,
  handleTagToggle
}: TagsFilterProps) => {
  const namedTags = tags.filter(
    (tag): tag is { guid: string; name: string } => !!tag.guid && !!tag.name
  )
  return (
    <FilterOptionRows
      sectionName={t('filters.tags')}
      name={filterName(variant, 'tags')}
      hasEntered={hasEntered}
      values={namedTags.map((tag) => ({ id: tag.guid, name: tag.name }))}
      selectedValues={
        new Set(
          selectedTags
            .map((tag) => tag.guid)
            .filter((guid): guid is string => guid != null)
        )
      }
      onToggle={(guid) => {
        const tag = namedTags.find((t) => t.guid === guid)
        if (tag) handleTagToggle(tag.guid, tag.name)
      }}
    />
  )
}
